module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_02 (9).02ab391.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_02 (9).mp4
// module id = 784
// module chunks = 1